export default __webpack_public_path__ + "static/flower3-d3febd6706f22975285bfe03db1e15d9.png";